/**
 * Closes a popup (a menu, a picker) when the pointer goes down outside it,
 * like native menus. Only listens while the popup is open.
 */
import { useEffect } from "react";
import type { RefObject } from "react";

export function useDismissOnOutsideClick(
  ref: RefObject<HTMLElement | null>,
  active: boolean,
  onDismiss: () => void,
): void {
  useEffect(() => {
    if (!active) return;
    const onPointerDown = (event: PointerEvent) => {
      if (!ref.current?.contains(event.target as Node)) onDismiss();
    };
    window.addEventListener("pointerdown", onPointerDown);
    return () => {
      window.removeEventListener("pointerdown", onPointerDown);
    };
  }, [ref, active, onDismiss]);
}
